<template>
  <!-- 입점 신청 안내 페이지 -->
  <div>
    <v-container pa-0 fluid>
      <div class="enter-title">간편 입점 신청 안내</div>
      <div ma-0 class="enter-block-all">
        <div class="enter-block-1">
          <div class="enter-block">
            <div class="enter-description-text">
              <div class="enter-description-text-1">01</div>
              <div class="enter-description-text-2">입점 신청 정보 입력</div>
            </div>
          </div>
          <div class="enter-block">
            <div class="enter-description-text">
              <div class="enter-description-text-1">02</div>
              <div
                class="enter-description-text-2 enter-description-text-2-spe"
              >
                담당자 전화 및 방문, <br />
                서류 작성 및 제출
              </div>
            </div>
          </div>
        </div>
        <div class="enter-block-2">
          <div class="enter-block">
            <div class="enter-description-text">
              <div class="enter-description-text-1">03</div>
              <div class="enter-description-text-2">서류 내부 심사</div>
            </div>
          </div>
          <div class="enter-block">
            <div class="enter-description-text">
              <div class="enter-description-text-1">04</div>
              <div class="enter-description-text-2">대구로 입점 완료</div>
            </div>
          </div>
        </div>
      </div>
      <div class="enter-how-to-1">
        <div>
          <div class="enter-how-to-text-1">01. 간편 입점 신청 정보 입력</div>
          <div class="enter-how-to-text-2">
            온라인으로 입점 신청을 진행합니다.
          </div>
          <div class="enter-how-to-block-all">
            <div class="enter-how-to-block">
              <div class="enter-how-to-block-title-1">ㆍ공통 준비 서류</div>
              <div>
                <div class="enter-how-to-block-left">
                  ① 사업자등록증 사본<br />
                  ② 통장 사본
                </div>
                <div class="enter-how-to-block-right">③ 영업 신고증 사본</div>
              </div>
            </div>
          </div>
        </div>
        <div class="enter-how-to-1-2">
          <div class="enter-how-to-text-1">
            02. 담당자 전화 및 방문하여
            <div class="mobile-space"></div>
            서류작성 및 제출
          </div>
          <div class="enter-how-to-text-2">
            대구로 담당자가 사장님께 직접 연락을 드리고
            <div class="mobile-space"></div>
            입점 신청 절차를 도와드립니다.<br />
            사장님께서 준비하실 것은 아래와 같습니다.
          </div>
        </div>
      </div>
      <div class="enter-how-to-block-all">
        <div class="enter-how-to-block">
          <div class="enter-how-to-block-title-1">ㆍ법인사업자 준비 서류</div>
          <div>
            <div class="enter-how-to-block-left">
              ① 법인등기부등본<br />
              ② 메뉴와 가격이 기입된 메뉴판
            </div>
            <div class="enter-how-to-block-right">③ 로고 이미지<br /></div>
          </div>
        </div>
        <div class="enter-how-to-block" id="enter-how-to-block-1">
          <div class="enter-how-to-block-title-2">ㆍ개인사업자 준비 서류</div>
          <div>
            <div class="enter-how-to-block-left">
              ① 메뉴와 가격이 기입된 메뉴판<br />
              ② 로고 이미지
            </div>
            <div class="enter-how-to-block-right"></div>
          </div>
        </div>
      </div>
      <div class="enter-how-to-1">
        <div>
          <div class="enter-how-to-text-1">03. 서류 내부 심사</div>
          <div class="enter-how-to-text-2">
            준비해주신 서류 및 수령한 정보를
            <div class="mobile-space"></div>
            대구로 담당자가 앱에 등록합니다.
          </div>
        </div>
        <div class="enter-how-to-1-2">
          <div class="enter-how-to-text-1">04. 대구로 입점 완료</div>
          <div class="enter-how-to-text-2">
            계약서 작성일 기준으로 대략 영업일 4주 후에
            <div class="mobile-space"></div>
            대구로 입점이 완료됩니다.
          </div>
        </div>
      </div>
      <!--      <router-link :to="{ name: 'Enter_Insert' }" class="enter-btn">
        <div>입점 신청하기</div>
      </router-link>-->

      <!-- <a :href="$router.resolve({name: 'Enter_Insert'}).href" class="enter-btn">
        <div>입점 신청하기</div>
      </a> -->
      <button class="enter-btn" @click="goInsert()">
        <div>입점 신청하기</div>
      </button>
    </v-container>
  </div>
</template>

<script>
export default {
  methods: {
    goInsert() {
      if (this.$router.currentRoute.name != "Enter_Insert") {
        this.$router.push({ name: "Enter_Insert" });
      }
    },
  },
};
</script>

<style scoped>
div {
  /* border: red solid 2px; */
  font-family: "PretendardRegular";
}

.container {
  font-family: "PretendardRegular";
}

/*
##Device = Desktops
##Screen = 1281px to higher resolution desktops
##Device = 데스크탑
##Screen = 1281px 이상 해상도 데스크탑
*/

@media (min-width: 1281px) {
  .container {
    width: 1170px !important;
  }
  .enter-title {
    height: 59px;
    font-family: "PretendardRegular";
    font-size: 40px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: left;
    color: #333333;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .enter-block-all {
    border-top: #333333 solid 2px;
    border-left: #e6e6e6 solid 1px;
    border-bottom: #e6e6e6 solid 1px;
  }
  .enter-block-all::after {
    display: block;
    content: "";
    clear: both;
  }
  .enter-block {
    width: 292px;
    height: 100px;
    /* margin: 0 291px 0 0;
    padding: 31px 52px 30px 47px;
    background-color: #ffffff;*/
    border-right: solid 1px #e6e6e6;
    float: left;
  }
  .enter-description-text {
    margin-top: 31px;
    margin-bottom: 30px;
    text-align: center;
    width: 210px;
    margin-left: auto;
    margin-right: auto;
  }
  .enter-description-text-1,
  .enter-description-text-2 {
    float: left;
  }
  .enter-description-text-1 {
    font-family: "RobotoRegular";
    /* margin-left: 47px; */
    width: 34px;
    height: 39px;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: -0.6px;
    text-align: center;
    color: #01c9ff;
  }
  .enter-description-text-2 {
    font-family: "PretendardRegular";
    margin-left: 20px;
    margin-top: 6px;
    margin-bottom: 6px;
    height: 27px;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #333333;
  }
  .enter-how-to-1 {
    font-family: "PretendardRegular";
    margin-top: 40px;
  }
  .enter-how-to-text-1 {
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }
  .enter-how-to-text-2 {
    margin-top: 8px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }
  .enter-how-to-1-2 {
    margin-top: 30px;
  }
  .enter-how-to-block-all {
    margin-top: 20px;
  }
  .enter-how-to-block-all::after {
    display: block;
    content: "";
    clear: both;
  }
  .enter-how-to-block {
    float: left;
    width: 48%;
    height: 152px;
    /* margin: 20px 20px 30px 0; */
    padding: 28px 101px 28px 28px;
    border: solid 2px #01c9ff;
  }
  .enter-how-to-block-left,
  .enter-how-to-block-right {
    float: left;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.28px;
    text-align: left;
    color: #333333;
    margin-top: 20px;
  }
  .enter-how-to-block-title-1,
  .enter-how-to-block-title-2 {
    /* width: 170px;
    height: 27px;
    margin: 0 99px 20px 0; */
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
  }
  .enter-how-to-block-title-1 {
    color: #01c9ff;
  }
  .enter-how-to-block-right {
    margin-left: 25%;
  }
  .enter-btn-block {
    margin-top: 26px;
  }
  .enter-btn {
    float: right;
    width: 288px;
    height: 60px;
    margin: 26px 0 60px 882px;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }
  #enter-how-to-block-1 {
    border-color: black;
    float: right;
  }
  .enter-description-text-2-spe {
    margin-top: -8px;
    margin-bottom: -7px;
  }
  .mobile-space {
    display: none;
  }
}

/*
##Device = Laptops, Desktops
##Screen = B/w 768px to 1280px
##Device = 랩탑, 데스크탑 + 태블릿 추가함
##Screen = 1025px에서 1280px 사이
*/

@media (min-width: 768px) and (max-width: 1280px) {
  .container {
    width: 586px !important;
  }
  .enter-title {
    height: 59px;
    font-family: "PretendardRegular";
    font-size: 40px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: center;
    color: #333333;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .enter-block-all {
    border-top: #333333 solid 1.2px;
    border-right: #e6e6e6 solid 1px;
    width: 586px;
    height: 200px;
  }
  .enter-block-1 {
    width: 768px;
  }
  .enter-block-2 {
    width: 768px;
  }
  .enter-block {
    width: 292px;
    height: 100px;
    border-left: solid 1px #e6e6e6;
    border-bottom: solid 1px #e6e6e6;
    float: left;
  }
  .enter-description-text {
    margin-top: 31px;
    margin-bottom: 30px;
    text-align: center;
    width: 210px;
    margin-left: auto;
    margin-right: auto;
  }
  .enter-description-text-1,
  .enter-description-text-2 {
    float: left;
  }
  .enter-description-text-1 {
    font-family: "RobotoRegular";
    /* margin-left: 47px; */
    width: 34px;
    height: 39px;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: -0.6px;
    text-align: center;
    color: #01c9ff;
  }
  .enter-description-text-2 {
    font-family: "PretendardRegular";
    margin-left: 20px;
    margin-top: 6px;
    margin-bottom: 6px;
    height: 27px;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #333333;
  }
  .enter-how-to-1 {
    font-family: "PretendardRegular";
    margin-top: 40px;
  }
  .enter-how-to-text-1 {
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }
  .enter-how-to-text-2 {
    margin-top: 8px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }
  .enter-how-to-1-2 {
    margin-top: 30px;
  }
  .enter-how-to-block-all {
    margin-top: 20px;
  }
  .enter-how-to-block-all::after {
    display: block;
    content: "";
    clear: both;
  }
  .enter-how-to-block {
    float: left;
    width: 586px;
    height: 150px;
    /* margin: 20px 20px 30px 0; */
    padding: 28px 37px 28px 28px;
    border: solid 2px #01c9ff;
  }
  .enter-how-to-block-left,
  .enter-how-to-block-right {
    float: left;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.28px;
    text-align: left;
    color: #333333;
    margin-top: 20px;
  }
  .enter-how-to-block-title-1,
  .enter-how-to-block-title-2 {
    /* width: 170px;
    height: 27px;
    margin: 0 99px 20px 0; */
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
  }
  .enter-how-to-block-title-1 {
    color: #01c9ff;
  }
  .enter-how-to-block-right {
    margin-left: 148px;
  }
  .enter-btn-block {
    margin-top: 26px;
  }
  .enter-btn {
    float: left;
    width: 288px;
    height: 60px;
    margin: 26px 0 60px 0;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }
  #enter-how-to-block-1 {
    border-color: black;
    float: right;
    margin-top: 20px;
  }
  .enter-description-text-2-spe {
    margin-top: -8px;
    margin-bottom: -7px;
  }
  .mobile-space {
    display: none;
  }
}

/*
##Device = Tablets, Ipads (portrait),
##Screen = B/w 768px to 1024px
##Device = 태블릿, 아이패드(세로),
##Screen = 768px에서 1024px 사이
*/

/* @media (min-width: 768px) and (max-width: 1024px) {
} */

/*
##Device = Tablets, Ipads (landscape)
##Screen = B/w 768px to 1024px
##Device = 태블릿, 아이패드(가로)
##Screen = 768px에서 1024px 사이
*/

/* @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
} */

/*
##Device = Low Resolution Tablets, Mobiles (Landscape)
##Screen = B/w 481px to 767px
##Device = 저해상도 태블릿, 모바일(가로)
##Screen = 481px에서 767px 사이
*/

@media (max-width: 767px) {
  .container {
    width: 324px !important;
  }
  .enter-title {
    height: 36px;
    font-family: "PretendardRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: center;
    color: #333333;
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .enter-block-all {
    border-top: #333333 solid 1.2px;
    border-right: #e6e6e6 solid 1px;
    width: 324px;
    height: 200px;
  }
  .enter-block-1 {
    width: 324px;
  }
  .enter-block-2 {
    width: 324px;
  }
  .enter-block {
    width: 162px;
    height: 100px;
    border-left: solid 1px #e6e6e6;
    border-bottom: solid 1px #e6e6e6;
    float: left;
  }
  .enter-description-text {
    /* margin-top: 31px;
    margin-bottom: 30px; */
    text-align: center;
    width: 162px;
    margin-top: 15px;
    margin-left: auto;
    margin-right: auto;
  }
  /*.enter-description-text-1,
  .enter-description-text-2 {
     float: left; 
  }*/
  .enter-description-text-1 {
    font-family: "RobotoRegular";
    /* margin-left: 47px; */
    width: 26px;
    height: 32px;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.48px;
    text-align: center;
    color: #01c9ff;
    margin-left: auto;
    margin-right: auto;
  }
  .enter-description-text-2 {
    font-family: "PretendardRegular";
    width: 113px;
    height: 20px;
    margin: auto;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.28px;
    text-align: center;
    color: #333333;
    margin-top: 1px;
  }
  .enter-how-to-1 {
    font-family: "PretendardRegular";
    margin-top: 40px;
  }
  .enter-how-to-text-1 {
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #333333;
  }
  .enter-how-to-text-2 {
    margin-top: 8px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.28px;
    text-align: center;
    color: #333333;
  }
  .enter-how-to-1-2 {
    margin-top: 30px;
  }
  .enter-how-to-block-all {
    margin-top: 20px;
  }
  .enter-how-to-block-all::after {
    display: block;
    content: "";
    clear: both;
  }
  .enter-how-to-block {
    float: left;
    width: 324px;
    height: 185px;
    /* margin: 20px 20px 30px 0; */
    padding: 28px 37px 28px 28px;
    border: solid 2px #01c9ff;
  }
  .enter-how-to-block-left,
  .enter-how-to-block-right {
    float: initial;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.28px;
    text-align: left;
    color: #333333;
    margin-top: 20px;
  }
  .enter-how-to-block-title-1,
  .enter-how-to-block-title-2 {
    /* width: 170px;
    height: 27px;
    margin: 0 99px 20px 0; */
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
  }
  .enter-how-to-block-title-1 {
    color: #01c9ff;
  }
  .enter-how-to-block-right {
    /* margin-left: 148px; */
    margin-top: 0px;
  }
  .enter-btn-block {
    margin-top: 26px;
  }
  .enter-btn {
    float: left;
    width: 324px;
    height: 60px;
    margin: 40px 0 50px 0;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }
  #enter-how-to-block-1 {
    border-color: black;
    float: right;
    margin-top: 20px;
    height: 160px;
  }
}

/*
##Device = Most of the Smartphones Mobiles (Portrait)
##Screen = B/w 320px to 479px
##Device = 대부분의 스마트폰 모바일 기기(세로)
##Screen = 320px에서 479px 사이
*/

/* @media (min-width: 320px) and (max-width: 480px) {
} */
</style>
